import { render, staticRenderFns } from "./Toast.vue?vue&type=template&id=48a4edf2&"
import script from "./Toast.vue?vue&type=script&lang=js&"
export * from "./Toast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a4edf2')) {
      api.createRecord('48a4edf2', component.options)
    } else {
      api.reload('48a4edf2', component.options)
    }
    module.hot.accept("./Toast.vue?vue&type=template&id=48a4edf2&", function () {
      api.rerender('48a4edf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Toast.vue"
export default component.exports